import React from 'react'
import { CoverImage } from '@!/Store/Common/components'
import { Box, Text, Flex, Separator, HStack, VStack, Link, Wrap } from '@chakra-ui/react'
import { AuthorList } from '@!/components/List'
import { isBlank, buildSearchUrl } from '@!/Util'
import { NewTag, FreeTag, DiscountTag } from '@!/User/Bookshelf/components/BookshelfTags'

// リスト表示
export default function BookshelfList({ books, handleClickBook }) {
  return (
    <>
      {books.map((book) => (
        <Box key={book.content_id}>
          <Flex cursor="pointer" onClick={() => handleClickBook(book.content_id)}>
            <Box mr={4} width="90px">
              <CoverImage src={book.image_url} alt={book.title_name} width="100%" />
            </Box>
            <VStack flex={1} justifyContent="space-between" alignItems="start">
              <Box>
                <HStack gap={1}>
                  {book.new_release_flag && (
                    <Box w="16px" h="16px" minW="16px" maxW="16px">
                      <NewTag />
                    </Box>
                  )}
                  <Text fontWeight="bold" color="label.primary">
                    {book.title_name}
                  </Text>
                </HStack>

                <Box my={2}>
                  {book.author_name && (
                    <Box>
                      <Text fontSize="3xs">
                        著者：
                        <AuthorList authors={book.author_name} />
                      </Text>
                    </Box>
                  )}
                  {!isBlank(book.sub_genre_names) && (
                    <Box>
                      <Text fontSize="3xs">
                        ジャンル：
                        {book.sub_genre_names
                          .map((subGenreName, index) => (
                            <Link key={`list-item-subgenre-name-${index}`} textDecoration="none" href={buildSearchUrl('category', subGenreName)}>
                              {subGenreName}
                            </Link>
                          ))
                          .reduce((prev, curr) => [prev, '、', curr])}
                      </Text>
                    </Box>
                  )}
                </Box>
              </Box>

              <Wrap gap={1} fontWeight="semibold" fontSize="3xs">
                {book.free_flag && <FreeTag />}
                {book.discount_flag && <DiscountTag />}
              </Wrap>
            </VStack>
          </Flex>
          <Separator my={4} />
        </Box>
      ))}
    </>
  )
}
